import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, actionPrefixes } from "@newsela/snitch";
import { buttonMarginCss } from "../Actions.style";
import getButtonProps from "../utils/getButtonProps";
import useEventProperties from "../utils/useEventProperties";

const ButtonWithTrackEvent = withTrackEvent(Button);

const propTypes = {
  annotationId: PropTypes.number,
  buttonFlavor: PropTypes.string,
  handleEdit: PropTypes.func,
  isAComment: PropTypes.bool,
  shouldShowDeleteConfirmation: PropTypes.bool,
};

const EditButton = ({
  annotationId,
  buttonFlavor,
  handleEdit,
  isAComment,
  shouldShowDeleteConfirmation,
}) => {
  const description = isAComment
    ? "Edit an annotation comment"
    : "Edit an annotation";
  const eventProperties = useEventProperties(
    annotationId,
    actionNames.update,
    description,
    actionPrefixes.initiate,
  );
  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: buttonMarginCss }}
      disabled={shouldShowDeleteConfirmation}
      onClick={handleEdit}
      {...getButtonProps(buttonFlavor)}
      {...eventProperties}
    >
      Edit
    </ButtonWithTrackEvent>
  );
};

EditButton.propTypes = propTypes;

export default EditButton;
